import { getScopeLabel, ScopeType } from "@dgi/utils";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Button, ButtonProps, Tooltip } from "@mui/material";
import { useHasPermission } from "hooks";
import { memo } from "react";

interface DeleteButtonProps extends ButtonProps {
  tooltip?: string;
  permissions?: ScopeType | ScopeType[];
}

function DeleteButton(props: DeleteButtonProps) {
  const {
    tooltip = "",
    size = "small",
    variant = "outlined",
    color = "error",
    permissions = [],
    ...otherButtonProps
  } = props;

  const [hasAccess, missingPermissions] = useHasPermission({
    matchAll: typeof permissions === "string" ? [permissions] : permissions,
  });

  // Create a tooltip letting the user know they're missing a permissions to perform
  // this action
  let noPermissionTooltip = "";
  if (!hasAccess) {
    if (typeof permissions === "string") {
      noPermissionTooltip = `You do not have permission to ${getScopeLabel(
        permissions
      ).toLowerCase()}`;
    } else {
      noPermissionTooltip = `You do not have permission to ${missingPermissions
        .map((scope) => getScopeLabel(scope).toLowerCase())
        .join(" or ")}`;
    }
  }

  const tooltipText = tooltip || noPermissionTooltip || "";

  return (
    <Tooltip title={tooltipText}>
      <span>
        <Button
          {...otherButtonProps}
          size={size}
          variant={variant}
          color={color}
          startIcon={<DeleteIcon />}
          disabled={!hasAccess || otherButtonProps.disabled}
        >
          {props.children}
        </Button>
      </span>
    </Tooltip>
  );
}

export default memo(DeleteButton);
